import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import { api, errMsg } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { Trash2, FilePlus, LibraryBig } from "lucide-react";
import { toast } from "sonner";

export default function TemplatesPage() {
  const [tpls, setTpls] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();
  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/templates"); setTpls(data); } catch(e){ toast.error(errMsg(e)); } setLoading(false);
  };
  useEffect(()=>{ load(); }, []);
  const spawn = async (id) => {
    try { const { data } = await api.post(`/projects/from-template/${id}`); toast.success("Project created from template"); nav(`/app/projects/${data.id}`); } catch(e){ toast.error(errMsg(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete template?")) return;
    try { await api.delete(`/templates/${id}`); setTpls((x)=>x.filter(t=>t.id!==id)); } catch(e){ toast.error(errMsg(e)); }
  };

  return (
    <AppLayout>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white" style={{fontFamily:'Outfit'}}>Templates</h1>
        <p className="text-slate-400 mt-1">Reusable project blueprints — create any project in one click.</p>
      </div>
      {loading ? <div className="text-slate-400">Loading…</div>
        : tpls.length === 0 ? (
          <div className="pc-card p-10 text-center" data-testid="empty-templates">
            <LibraryBig className="mx-auto text-blue-400 mb-3" size={36}/>
            <div className="text-xl font-semibold text-white mb-1" style={{fontFamily:'Outfit'}}>No templates yet</div>
            <p className="text-slate-400">Open any project and click "Save as template" to create one.</p>
          </div>
        ) : (
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="templates-grid">
            {tpls.map(t=> (
              <div key={t.id} className="pc-card p-5" data-testid={`template-card-${t.id}`}>
                <div className="text-lg font-semibold text-white mb-1" style={{fontFamily:'Outfit'}}>{t.name}</div>
                <p className="text-sm text-slate-400 mb-3 line-clamp-2 min-h-[2.5rem]">{t.description || "No description"}</p>
                <div className="text-xs text-slate-500 mb-4">{(t.source_tasks||[]).length} tasks</div>
                <div className="flex gap-2">
                  <button onClick={()=>spawn(t.id)} data-testid={`use-template-${t.id}`} className="flex-1 bg-blue-600 hover:bg-blue-500 text-white px-3 py-2 rounded-lg text-sm inline-flex items-center justify-center gap-2"><FilePlus size={14}/> New project</button>
                  <button onClick={()=>remove(t.id)} className="border border-slate-700 hover:border-rose-500 text-slate-300 hover:text-rose-300 px-3 py-2 rounded-lg"><Trash2 size={14}/></button>
                </div>
              </div>
            ))}
          </div>
        )}
    </AppLayout>
  );
}
